export default __webpack_public_path__ + "static/media/createAssignTemplate1.08ed5a4e.gif";